<template>
  <div
    v-if="visible"
    class="fixed inset-x-0 bottom-0 z-[1000] bg-white border-t border-gray-200 shadow-[0_-2px_12px_rgba(0,0,0,0.08)] p-4"
    role="dialog"
    aria-live="polite"
    :aria-label="t.title"
  >
    <div class="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center">
      <p class="flex-1 text-sm text-gray-700">
        <span class="font-semibold">{{ t.title }}</span>
        {{ t.body }}
      </p>
      <div class="flex shrink-0 gap-2">
        <button
          type="button"
          class="rounded-md border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
          @click="choose('denied')"
        >
          {{ t.reject }}
        </button>
        <button
          type="button"
          class="rounded-md bg-gray-900 px-4 py-2 text-sm font-semibold text-white hover:bg-gray-700"
          @click="choose('granted')"
        >
          {{ t.accept }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  CONSENT_EVENT,
  isLikelyRegulatedRegion,
  pushConsentUpdate,
  readConsentChoice,
  writeConsentChoice,
  type ConsentChoice,
} from '~/utils/consent'

// Strings are component-local (EN only for now): i18n/locales/en.json carries
// unrelated uncommitted changes in the working tree, so banner strings could
// not be added there in this branch. Follow-up: move to locale files + add
// the other 6 languages.
const t = {
  title: 'Cookies & privacy.',
  body: 'We use cookies to measure our advertising and improve your experience. You can accept or reject non-essential cookies.',
  accept: 'Accept all',
  reject: 'Reject non-essential',
}

// Rendered inside <ClientOnly>, so window/document are safe here; visibility
// still starts false and flips in onMounted to avoid any first-paint flash.
const visible = ref(false)

onMounted(() => {
  visible.value = isLikelyRegulatedRegion() && readConsentChoice() === null
})

function choose(choice: ConsentChoice) {
  writeConsentChoice(choice)
  pushConsentUpdate(choice)
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { choice } }))
  visible.value = false
}
</script>
